/** Organic section lifecycle. Native Shopify product/cart components are separate. */
(() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const activeAnimations = new Set();
  const targets = '.po-hero__copy, .po-brand__copy, .po-brand__photo, .po-path, .po-trade__grid';

  function motionEnabled(element) {
    const section = element.closest('[data-po-section]');
    return !preference.matches && document.body.dataset.poMotion !== 'false' &&
      section?.dataset.poMotion !== 'false' && !window.Shopify?.designMode;
  }

  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      if (!motionEnabled(entry.target)) continue;

      const duration = Number(document.body.dataset.poDuration) || 650;
      const photo = entry.target.matches('.po-path, .po-brand__photo');
      const frames = photo
        ? { transform: ['translateY(22px) rotate(-1deg)', 'translateY(0)'], opacity: [.5, 1] }
        : { transform: ['translateY(18px)', 'translateY(0)'], opacity: [.5, 1] };
      const animation = entry.target.animate(frames, {
        duration,
        easing: 'cubic-bezier(.16,1,.3,1)'
      });
      activeAnimations.add(animation);
      animation.finished.catch(() => {}).finally(() => activeAnimations.delete(animation));
    }
  }, { threshold: .15 });

  function initialize(root) {
    root.querySelectorAll(targets).forEach(element => observer.observe(element));
  }

  function release(root) {
    root.querySelectorAll(targets).forEach(element => observer.unobserve(element));
    for (const animation of activeAnimations) {
      if (root.contains(animation.effect?.target)) animation.cancel();
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-po-scroll]');
    if (!button) return;
    const rail = document.getElementById(button.getAttribute('aria-controls'));
    if (!rail) return;
    rail.scrollBy({
      left: rail.clientWidth * .8 * Number(button.dataset.poScroll),
      behavior: motionEnabled(rail) ? 'smooth' : 'instant'
    });
  });

  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => release(event.target));
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.closest('details');
    if (details) details.open = true;
    const card = event.target.closest('.po-card');
    if (card) card.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' });
  });
  preference.addEventListener('change', () => {
    if (preference.matches) activeAnimations.forEach(animation => animation.cancel());
  });
  initialize(document);
})();
